import { render } from "./SurveyCompleteComponent.vue?vue&type=template&id=0f3188b8"
import script from "./SurveyCompleteComponent.vue?vue&type=script&lang=js"
export * from "./SurveyCompleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__